import { Controller } from "@hotwired/stimulus"

// Lite YouTube embed — shows a thumbnail with a play button.
// Only loads the YouTube iframe when the user clicks play.
// Zero YouTube branding or overlays until interaction.
export default class extends Controller {
  static targets = ["poster", "player"]
  static values = { videoId: String }

  play() {
    const iframe = document.createElement("iframe")
    iframe.className = "absolute inset-0 w-full h-full"
    iframe.src = `https://www.youtube-nocookie.com/embed/${this.videoIdValue}?autoplay=1&rel=0&modestbranding=1&showinfo=0&controls=1`
    iframe.title = "GolfTap Overview"
    iframe.frameBorder = "0"
    iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    iframe.allowFullscreen = true

    this.playerTarget.appendChild(iframe)
    this.playerTarget.classList.remove("hidden")
    this.posterTarget.classList.add("hidden")
  }
}
